import CourseVerticalGridView from "@/components/discussion/CourseVerticalGridView.vue";
import TimelinePoster from "@/components/discussion/TimelinePoster.vue";
import TimelineItem from "@/components/discussion/TimelineItem.vue";
import Vue from "vue";
import { EventBus } from "@/event-bus";

export default {
    components: {
        CourseVerticalGridView,
        TimelinePoster,
        TimelineItem,
    },
    data: () => ({
        showSkeleton: true,
        portfolio: [],
        allowPost: false,
        loading: false,
        profile: null,
        filter: 0,
        // url: 'https://api.nerdof.com/api',
        url: "http://localhost/api",
    }),
    computed: {
        courseId() {
            return this.$route.params.id;
        },
        bc() {
            return [
                {
                    text: this.$utility.shortenText(
                        "Cloud computing for neural networks. How to run Jupyter notebook with Tensorflow in the cloud",
                        64
                    ),
                    to: {
                        name: "course_detail",
                        params: {
                            id: this.$route.params.id,
                        },
                    },
                },
                {
                    text: "Discussion",
                    disabled: false,
                },
            ];
        },
    },
    mounted() {
        this.init();
        EventBus.$on("editPoster", (data) => {
          this.$refs.poster.edit(data)
        });
    },
    beforeDestroy(){
        EventBus.$off("editPoster")
    },
    methods: {
        init() {
            this.fetch();
            // sample test
            // this.portfolio = this.genSample();
        },

        fetch() {
            this.profile = null;
            this.showSkeleton = true;
            const userInfo = Vue.prototype.$userInfo;
            this.$http
                .get(
                    `${this.$store.state.api}/account/profile/teacher?id=${userInfo._id}`
                )
                .then((resp) => {
                    if (resp.data.status == true) {
                        this.profile = resp.data.result;
                    } else {
                        this.profile = null;
                    }
                })
                .catch((err) => {
                    this.profile = null;
                })
                .finally(() => {
                    this.showSkeleton = false;
                });
        },
    },
};